import React__default from 'react';
import { Typography } from './Typography.mjs';

const Instruction = ({ children })=>/*#__PURE__*/ React__default.createElement(Typography, {
        variant: "body2"
    }, children);

export { Instruction };
//# sourceMappingURL=Instruction.mjs.map
